import { ExternalLinkIcon } from "@gadgetinc/widgets/src/icons/ExternalLinkIcon";
import { useStyletron } from "baseui";
import type { ReactNode } from "react";
import * as React from "react";
import { DocsButton } from "../components/DocsButton";
import { Callout } from "./Callout";

export const ForkButtonCallout = ({ domain, children }: { domain: string; children: ReactNode }) => {
  return (
    <Callout>
      {children}

      <ForkButton domain={domain} />
    </Callout>
  );
};

export const ForkButton = ({ domain }: { domain: string }) => {
  const [css, $theme] = useStyletron();
  return (
    <DocsButton
      $as="a"
      href={`https://app.gadget.dev/auth/fork?domain=${domain}`}
      target="_blank"
      overrides={{
        BaseButton: {
          style: {
            marginBottom: $theme.sizing.scale600,
          },
        },
      }}
    >
      Fork template on Gadget&nbsp;
      <ExternalLinkIcon />
    </DocsButton>
  );
};
